import localhost, { downloadFileFromResponse } from "apis/localhost";
import { modalTypes } from "constants/types";
import { showErrorModal } from "slices/app/actions/error";
import {
  addToJobQueue,
  clearJobQueue,
  disableNavBarAndSideBar,
  showInlineAlert,
} from "slices/app/appSlice";
import { hideModal } from "slices/app/actions/modals";
import { alertVariants } from "@visiblethread/react-components/dist/components/Alert";
import {
  cancelEdits,
  setEditMode,
  setIgnoreList,
  setLocked,
} from "slices/settings/slices/readabilityIgnoreSlice";

export const fetchReadabilityIgnoreList = () => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .get("/docs/readabilityConfiguration/")
    .then((response) => {
      const { data } = response;
      dispatch(setIgnoreList(data));
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const cancelChanges = () => (dispatch) => {
  dispatch(cancelEdits());
  dispatch(setEditMode(false));
  dispatch(disableNavBarAndSideBar(false));
};

export const openEditMode = () => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .get("/docs/readabilityConfiguration/lock")
    .then(() => {
      dispatch(setEditMode(true));
      dispatch(disableNavBarAndSideBar(true));
    })
    .catch((error) => {
      const message = error.response.data.error;
      if (message.includes("is currently editing it")) {
        dispatch(setLocked(true));
        dispatch(
          showInlineAlert({ variant: alertVariants.warning, text: message })
        );
      } else {
        dispatch(showErrorModal(error));
      }
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const closeEditMode = () => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .get("/docs/readabilityConfiguration/unlock")
    .then(() => {
      dispatch(cancelChanges());
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const setReadabilityIgnoreList = (ignoreList) => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .post("/docs/readabilityConfiguration/edit/", {
      whitelist: ignoreList
        .filter((term) => term.term)
        .map((term) => term.term),
    })
    .then((response) => {
      const { data } = response;
      dispatch(setIgnoreList(data));
      dispatch(setEditMode(false));
      dispatch(disableNavBarAndSideBar(false));
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const exportReadabilityIgnoreList = () => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .get("/docs/readabilityConfiguration/export", {
      responseType: "blob",
    })
    .then(async (response) => {
      const { data } = response;
      downloadFileFromResponse(data, `ReadabilityIgnoreList.csv`);
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const importReadabilityIgnoreList = (formData) => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .post("/docs/readabilityConfiguration/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(async (response) => {
      const { data } = response;
      dispatch(setIgnoreList(data));
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(hideModal(modalTypes.IMPORT_FILE));
      dispatch(clearJobQueue());
    });
};
